function checkSocNumberExists(socNumber: string) {
  if (!socNumber) {
    throw new InvalidSocNumberError();
  }
}

export function extractSocNumber(socNumber: string) {
  checkSocNumberExists(socNumber);

  const socNumberMatches = `${socNumber}`.match(/[A-Za-z0-9]+$/);

  if (!socNumberMatches) {
    throw new InvalidSocNumberError();
  }
  const [socCode] = socNumberMatches;
  const upperCaseCode = socCode.toUpperCase();

  // A valid SOC code is either all numbers (legacy) or a 6-character alphanumeric string with region prefix.
  const isLegacy = /^\d+$/.test(upperCaseCode);
  // Check without region prefix
  const isNewFormat = /^[B-DF-HJ-NP-TV-Z0-9]{4,}$/i.test(
    upperCaseCode.substring(1)
  );

  if (!isLegacy && !isNewFormat) {
    throw new InvalidSocNumberError();
  }

  return upperCaseCode;
}

export class InvalidSocNumberError extends Error {
  constructor() {
    super('Invalid SOC code format.');
    this.name = 'InvalidSocNumberError';
  }
}
